import { Navigate } from "react-router";

const UserRoute = ({ children }) => {
    const role = localStorage.getItem("role") || undefined;
    return role !== "admin" && role !== "producer" && role !== "manager"  ? children : <Navigate to="/login" />;
  };
  
  export default UserRoute;